<footer class="flex-shrink-0 rounded-2xl overflow-hidden mx-6 lg:mx-8 mb-6" style="background: var(--dgpe-navy)">
    <div class="flex flex-col sm:flex-row items-center justify-between gap-2 px-4 lg:px-6 py-3 text-xs" style="color: rgba(255, 255, 255, 0.85)">
        <!-- Copyright -->
        <p class="flex items-center gap-1.5 text-center sm:text-left" style="color: rgba(255, 255, 255, 0.85)">
            <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" style="color: rgba(255, 255, 255, 0.85)" viewBox="0 0 24 24">
                <path
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2" />
            </svg>
            <span
                >&copy; {{ currentYear }} SISPE - DGPE. All rights reserved. Powered by
                <a href="https://www.barnoininformatique.com/" rel="noopener noreferrer" style="color: #ffffff; font-weight: 600" target="_blank"
                    >Barnoin Informatique</a
                >
                &
                <a href="https://n-socitech.com/" rel="noopener noreferrer" style="color: #ffffff; font-weight: 600" target="_blank"
                    >N-SociTech</a
                ></span
            >
        </p>

        <!-- Links -->
        <nav class="flex items-center gap-4">
            <a
                class="flex items-center gap-1 transition-colors"
                href="#"
                onmouseout="this.style.color = 'rgba(255,255,255,0.85)'"
                onmouseover="this.style.color = 'rgba(255,255,255,0.9)'"
                style="color: rgba(255, 255, 255, 0.85)">
                <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2" />
                </svg>
                Conditions d'utilisation
            </a>
            <a
                class="flex items-center gap-1 transition-colors"
                href="#"
                onmouseout="this.style.color = 'rgba(255,255,255,0.85)'"
                onmouseover="this.style.color = 'rgba(255,255,255,0.9)'"
                style="color: rgba(255, 255, 255, 0.85)">
                <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2" />
                </svg>
                Politique de confidentialité
            </a>
            <a
                class="flex items-center gap-1 transition-colors"
                href="#"
                onmouseout="this.style.color = 'rgba(255,255,255,0.85)'"
                onmouseover="this.style.color = 'rgba(255,255,255,0.9)'"
                style="color: rgba(255, 255, 255, 0.85)">
                <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2" />
                </svg>
                Support
            </a>
        </nav>
    </div>
</footer>
